<!--NOTIFICATION BANNER-->
<ng-container *ngIf="maintenance && maintenance?.display_notification">
  <section class="notification">
    <!--WRAPPER BLOCK-->
    <div class="wrapper padding-top-small padding-bottom-small">
      <!--HTML CMS CONTENT-->
      <div class="maintenance-content" [innerHTML]="maintenance?.content"></div>
      <!--END HTML CMS CONTENT-->
      <!--CLOSE BUTTON-->
      <button class="border-none" (click)="closeMaintenanceNotification(maintenance)">
        <i class="icon red small plus cursor left"></i>
      </button>
      <!--END CLOSE BUTTON-->
    </div>
    <!--END WRAPPER BLOCK-->
  </section>
</ng-container>
<!--END NOTIFICATION BANNER-->
